// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NodeBoxButton_button__7lgOw {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  min-width: 24px;
  padding: 0 4px;
  border-radius: 4px;
  color: white;
  background-color: #454545;
}
.NodeBoxButton_button__7lgOw img, .NodeBoxButton_button__7lgOw i {
  min-width: 16px;
}
.NodeBoxButton_button__7lgOw[data-on=true] {
  background-color: #28a745;
}
.NodeBoxButton_button__7lgOw:disabled {
  background-color: lightgray;
  cursor: not-allowed;
}
.NodeBoxButton_button__7lgOw[data-action-bar=true] {
  color: #454545;
  background-color: white;
}
.NodeBoxButton_button__7lgOw[data-action-bar=true][data-on=true] i {
  color: #28a745;
}
.NodeBoxButton_button__7lgOw[data-action-bar=true]:disabled {
  color: lightgray;
  cursor: not-allowed;
}
.NodeBoxButton_button__7lgOw[data-on-off=true] {
  width: 56px;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/Buttons/NodeBoxButton.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EAEA,YAAA;EACA,yBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,2BAAA;EACA,mBAAA;AAFJ;AAKE;EACE,cAAA;EACA,uBAAA;AAHJ;AAMM;EAAI,cAAA;AAHV;AAMI;EACE,gBAAA;EACA,mBAAA;AAJN;AAQE;EACE,WAAA;AANJ","sourcesContent":[".button {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 24px;\n  min-width: 24px;\n  padding: 0 4px;\n  border-radius: 4px;\n  color: white;\n  background-color: #454545;\n}\n.button img, .button i {\n  min-width: 16px;\n}\n.button[data-on=true] {\n  background-color: #28a745;\n}\n.button:disabled {\n  background-color: lightgray;\n  cursor: not-allowed;\n}\n.button[data-action-bar=true] {\n  color: #454545;\n  background-color: white;\n}\n.button[data-action-bar=true][data-on=true] i {\n  color: #28a745;\n}\n.button[data-action-bar=true]:disabled {\n  color: lightgray;\n  cursor: not-allowed;\n}\n.button[data-on-off=true] {\n  width: 56px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `NodeBoxButton_button__7lgOw`
};
export default ___CSS_LOADER_EXPORT___;
